import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-long-card',
  templateUrl: './long-card.component.html',
  styleUrls: ['./long-card.component.scss']
})
export class LongCardComponent implements OnInit {
  @Input() embedMode: boolean = false;

  constructor() { }

  ngOnInit(): void {
  }

}
